import appConfig from "../config/appConfig";
import { logout, refreshToken, script_appender } from "../helpers/function";
import ls from "localstorage-slim";
import { logoutAndRedirectToLogin } from "../helpers/function";
import { verifyTokenExpire, verifyTokenMinutes } from "middleware/verifyToken";

export default function setupAxios(axios, store) {
  axios.defaults.withCredentials = true;
  const PUBLIC_PATH_REGEXES = [
    /^\/forgot-password\/[^/]+$/
  ];
  const isPublicPath = () => {
    try {
      const pathname = window.location.pathname;
      return PUBLIC_PATH_REGEXES.some((r) => r.test(pathname));
    } catch (e) {
      return false;
    }
  };

  axios.interceptors.request.use(
    (config) => {
      const token = ls.get("token");
      config.baseURL = appConfig.apiDomaine;
      config.headers.post["Content-Type"] = "application/json";
      // config.headers.post["X-Content-Type-Options"] = "nosniff";
      // config.headers.post["X-XSS-Protection"] = "1; mode=block";
      if (token && !config.headers.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (err) => Promise.reject(err)
  );

  async function logoutUserAndRedirectToLogin(ifCb, elseCb) {
    if (!window.location.href.endsWith("/login")) {
      if (ls.get("userData") == null || ls.get("token") == null || !verifyTokenExpire()) {
        logoutAndRedirectToLogin();
        return;
      }
      // Si le token n'est pas expiré et que la date expiration <= 5min
      if (verifyTokenMinutes()) {
        // Évite les refresh multiples
        if (!ls.get("refreshToken")) {
          ls.set("refreshToken", true);
          try {
            await refreshToken(); // On attend que le refresh soit terminé
          } catch (err) {
            // Si le refresh échoue, on déconnecte le user
            logoutAndRedirectToLogin();
            return;
          }
        }
        return ifCb();
      }
      return ifCb();
    } else {
      return elseCb();
    }
  }
  
  // Interceptor de réponse Axios
  axios.interceptors.response.use(
    async (response) => {

      if (isPublicPath()) {
        return response;
      }
      // Si aucun refresh en cours
      if (!ls.get("refreshToken")) {
        
        // Scripts à réinjecter dans la page (non lié au token)
        script_appender("/assets/js/jquery.tablesorter.min.js");
        script_appender("/assets/js/main.js");

        return await logoutUserAndRedirectToLogin(
          () => response, 
          () => response 
        );
      }

      // Une fois que le token est refreshé, on nettoie la session
      ls.remove("refreshToken");
      return response;
    },
    async (error) => {
      if (isPublicPath()) {
        return Promise.reject(error);
      }
      // On gère les erreurs ici normalement (ex: 401)
      if (
        window.location.href !== "/login" &&
        ls.get("userData") !== null &&
        error.response?.status === 401 &&
        error.response?.data?.error?.toLowerCase() === "unauthenticated"
      ) {
        const originalRequest = error.config || {};

        // Empêche une boucle infinie de retry
        if (!originalRequest._retry) {
          originalRequest._retry = true;

          try {
            // Marque un refresh global pour éviter plusieurs refresh concurrents
            if (!ls.get("refreshToken")) {
              ls.set("refreshToken", true);
              await refreshToken();
              ls.remove("refreshToken");
            }

            const newToken = ls.get("token");
            if (newToken) {
              originalRequest.headers = originalRequest.headers || {};
              if (!originalRequest.headers.Authorization) {
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
              }
              return axios(originalRequest);
            }
          } catch (e) {
            // Si le refresh échoue, on déconnecte l'utilisateur
            ls.remove("userData");
            logout();
            return Promise.reject(e);
          }
        }

        // Si on arrive ici, on n'a pas pu/du refresh : on déconnecte
        ls.remove("userData");
        logout();
      } else if (error.response?.status === 403) {
        const currentPath = window.location.pathname;

        if (error.response.data?.reset_pwd === true) {
          const target = "/settings/account/change-password";
          if (currentPath !== target) {
            window.location.href = target;
          }

        } else if (error.response.data?.["2fa_required"] === true) {
          const target = "/verify-2fa";
          if (currentPath !== target) {
            window.location.href = target;
          }

        } else if (error.response.data?.["2fa_already_verified"] === true) {
          const target = "/dashboard";
          if (currentPath !== target) {
            window.location.href = target;
          }
        }
      }
      return Promise.reject(error);
    }
  );
}
